<div class="floating-details activeDetails">
  <div class="d-flex h-100">
    <div class="overlay" (click)="closeDetails.emit(true)">
      <div class="closeDetails">
        <img src="./assets/images/close-icon.svg" alt="">
      </div>
    </div>
    <div *ngIf='dataLoading' class="dataLoading">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <ng-container *ngIf="!dataLoading">
      <div class="details-container" >
        <div class="content" >
          <div class="tab-head page-filters inner-filter mt-0">
            <span class="title-head"> {{ 'meetings.Meeting Details' | translate }}</span>
          </div>
          <div class="details-items pb-0 pt-0">
            <div class="row">
              <div class="col-12" *ngIf="details.companyName">
                <div class="one-item mb-0">
                  <div>
                    <span class="label-text">
                      {{ 'meetings.Company Name' | translate }}
                    </span>
                  </div>
                  <div>
                    <span class="label-value title">
                      {{details.companyName}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="one-item d-flex align-items-center" *ngIf="details.countryName">
                  <div class="name-with-image">
                    <div class="image-circle mr-3">
                      <div class="image m-0">
                        <img *ngIf="details.flagSVG" [src]="details.flagSVG"
                          (error)="details.flagSVG = ''" />
                        <span *ngIf="!details.flagSVG">{{ initName(details.countryName) | uppercase }}</span>
                      </div>
                    </div>
                    <div class="name">
                      <h5> {{details.countryName}}</h5>
                    </div>
                  </div>
                  <div class="employ-count">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="16" viewBox="0 0 30 16">
                      <path id="employees-icon"
                        d="M40.678,25.973v-.941a5.182,5.182,0,0,0-2.53-4.452,3.574,3.574,0,1,0-5.253,0,5.186,5.186,0,0,0-1.022.8,7.247,7.247,0,0,0-3.061-2.838,4.844,4.844,0,1,0-6.268,0,7.248,7.248,0,0,0-3.061,2.838,5.187,5.187,0,0,0-1.022-.8,3.574,3.574,0,1,0-5.253,0,5.182,5.182,0,0,0-2.53,4.452v.941Zm-6.855-7.824a1.7,1.7,0,1,1,1.7,1.706A1.7,1.7,0,0,1,33.823,18.149Zm-1.145,5.24a3.276,3.276,0,0,1,5.989.7H32.8C32.775,23.862,32.729,23.609,32.678,23.389Zm-9.969-8.554a2.969,2.969,0,1,1,2.969,2.98A2.978,2.978,0,0,1,22.709,14.836ZM25.678,19.7a5.328,5.328,0,0,1,5.23,4.392H20.448A5.328,5.328,0,0,1,25.678,19.7ZM14.135,18.149a1.7,1.7,0,1,1,1.7,1.706A1.7,1.7,0,0,1,14.135,18.149Zm-1.446,5.941a3.276,3.276,0,0,1,5.989-.7c-.051.22-.1.472-.127.7Z"
                        transform="translate(-10.678 -9.973)" fill="#b3bcc5" />
                    </svg>
                    <span>{{details.numberOfEmployees}} {{ 'meetings.Employees' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pt-3 pb-2">
              <div class="col-12">
                <!-- <div class="one-item d-flex align-items-center" *ngIf="details.status == 1">
                  <span class="tag-status light-yallow">
                    {{ 'meetings.Pending Confirmation' | translate }}
                  </span>
                  <span> <i> {{ 'meetings.Waiting your decision' | translate }}</i></span>
                </div>

                <div class="one-item" *ngIf="details.status == 2">
                  <span class="tag-status light-green">
                    {{ 'meetings.Upcoming' | translate }}
                  </span>
                </div>

                <div class="one-item" *ngIf="details.status == 3">
                  <span class="tag-status red">
                    {{ 'meetings.Declined' | translate }}
                  </span>
                </div>

                <div class="one-item" *ngIf="details.status == 4">
                  <span class="tag-status grey">
                    {{ 'meetings.Rescheduled' | translate }}
                  </span>
                </div> -->

                <div class="d-flex align-items-center status-waiting mb-3" *ngIf="details.status == 1">
                  <svg width="12" height="12" viewBox="0 0 12 12">
                    <circle id="circle" cx="6" cy="6" r="6" />
                  </svg>
                  <span class="text-custom p-0 pl-2">
                    {{ 'meetings.Pending Confirmation' | translate }}
                  </span>
                </div>
                <div class="d-flex align-items-center status-active mb-3" *ngIf="details.status == 2">
                  <svg width="12" height="12" viewBox="0 0 12 12">
                    <circle id="circle" cx="6" cy="6" r="6" />
                  </svg>
                  <span class="text-custom p-0 pl-2">
                    {{ 'meetings.Upcoming' | translate }}
                  </span>
                </div>
                <div class="d-flex align-items-center status-inactive mb-3" *ngIf="details.status == 3">
                  <svg width="12" height="12" viewBox="0 0 12 12">
                    <circle id="circle" cx="6" cy="6" r="6" />
                  </svg>
                  <span class="text-custom p-0 pl-2">
                    {{ 'meetings.Declined' | translate }}
                  </span>
                </div>

                <div class="d-flex align-items-center status-Eligible mb-3" *ngIf="details.status == 4">
                  <svg width="12" height="12" viewBox="0 0 12 12">
                    <circle id="circle" cx="6" cy="6" r="6" />
                  </svg>
                  <span class="text-custom p-0 pl-2">
                    {{ 'meetings.Rescheduled' | translate }}
                  </span>
                </div>

              </div>
            </div>
            <div class="meeting-info d-block">
              <div class="one-item" *ngIf="details.meetingDate">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" meeting-infowBox="0 0 20 20">
                    <path id="date-icon"
                      d="M2.668,20a2.654,2.654,0,0,1-1.889-.793A2.72,2.72,0,0,1,0,17.293V4.473a2.685,2.685,0,0,1,2.668-2.7h2V.742A.678.678,0,0,1,4.982.1a.662.662,0,0,1,.706,0A.681.681,0,0,1,6,.742V4.473a.681.681,0,0,1-.313.641.662.662,0,0,1-.706,0,.679.679,0,0,1-.312-.641V3.126h-2A1.346,1.346,0,0,0,1.331,4.473V6.491H18.669V4.467a1.346,1.346,0,0,0-1.331-1.347h-.669a.665.665,0,0,1-.633-.316.685.685,0,0,1,0-.715.665.665,0,0,1,.633-.316h.662A2.684,2.684,0,0,1,20,4.473v12.82a2.716,2.716,0,0,1-.779,1.914A2.652,2.652,0,0,1,17.331,20ZM1.337,17.293A1.346,1.346,0,0,0,2.668,18.64H17.331a1.346,1.346,0,0,0,1.337-1.347V7.851H1.337ZM4.5,13.5A.5.5,0,0,1,4,13V11.5a.5.5,0,0,1,.5-.5H6a.5.5,0,0,1,.5.5V13a.5.5,0,0,1-.5.5Zm9.813-8.385A.679.679,0,0,1,14,4.473V3.126H12V3.119a.666.666,0,0,1-.633-.316.685.685,0,0,1,0-.715A.666.666,0,0,1,12,1.773h2V.742A.678.678,0,0,1,14.313.1a.662.662,0,0,1,.706,0,.681.681,0,0,1,.313.64V4.473a.681.681,0,0,1-.313.641.662.662,0,0,1-.706,0ZM9.331,4.473V3.126h-2V3.119a.677.677,0,0,1,0-1.346h2V.742a.668.668,0,0,1,1.331,0V4.473a.668.668,0,0,1-1.331,0Z"
                      transform="translate(0 0)" fill="#F87F0F" />
                  </svg>
                </div>
                <div class="item">
                  <div class="label">
                    {{ 'bookademo.Meeting Date & Time' | translate }}
                  </div>
                  <div class="value">
                    {{details.meetingDate | date: 'fullDate'}}  {{'0000-00-00T' + details.meetingTime  | date:'h:mm aa'}}
                    <span>({{details.timeZone}})</span>
                  </div>
                </div>

              </div>
              <div class="one-item" *ngIf="details.meetingDuration">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path id="duration-icon"
                      d="M8.348,20a.814.814,0,0,1-.119-.008,9.865,9.865,0,0,1-3.983-1.684,10.105,10.105,0,0,1-1.283-1.074l-.014-.018A9.994,9.994,0,0,1,.151,11.8c-.033-.184-.062-.391-.086-.613L.06,11.159v-.016c-.02-.18-.037-.379-.049-.611v-.021A10.026,10.026,0,0,1,1.6,4.621L1.608,4.6l0-.006c0-.006,0-.01.008-.014.072-.115.141-.219.211-.316.045-.062.09-.123.135-.184a.031.031,0,0,1,.01-.016s0-.008.008-.008l0-.006L2,4.033A9.872,9.872,0,0,1,7.5.322l.012,0h.01l.012,0c.281-.07.529-.123.76-.164A10.136,10.136,0,0,1,10.021,0a9.873,9.873,0,0,1,5.547,1.709l.125.084L16.416.736c.061-.082.105-.1.121-.1s.053.033.082.143l.746,2.7a.318.318,0,0,1-.041.275.326.326,0,0,1-.242.137l-2.77.246a.19.19,0,0,1-.045,0c-.082,0-.109-.023-.113-.029s0-.068.055-.154L14.936,2.9l-.129-.086a8.628,8.628,0,0,0-9.733.078l-.031.021a8.767,8.767,0,0,0-.035,14.3,8.2,8.2,0,0,0,.8.508l.023.016c.188.1.336.174.479.242,0,0,0,0,.006,0s0,0,.006,0l.008,0a8.649,8.649,0,0,0,2.13.68A.672.672,0,0,1,9,19.449.663.663,0,0,1,8.348,20Zm3.346,0a.667.667,0,0,1-.383-.123.672.672,0,0,1,.262-1.209c.191-.035.359-.074.516-.113a.663.663,0,0,1,.8.49.673.673,0,0,1-.074.506.683.683,0,0,1-.41.307c-.24.059-.43.1-.6.127A.534.534,0,0,1,11.693,20Zm2.977-1.109a.665.665,0,0,1-.383-.121.724.724,0,0,1-.2-.211.679.679,0,0,1,.246-.916c.16-.1.313-.189.449-.283a.691.691,0,0,1,.365-.109.658.658,0,0,1,.555.3.671.671,0,0,1,.1.5.663.663,0,0,1-.287.424c-.152.1-.328.213-.516.324A.7.7,0,0,1,14.67,18.887Zm2.438-2.043a.673.673,0,0,1-.381-.121.475.475,0,0,1-.049-.039.676.676,0,0,1-.074-.945c.1-.121.211-.256.33-.414a.655.655,0,0,1,.928-.135.67.67,0,0,1,.133.936c-.105.145-.227.3-.379.482A.667.667,0,0,1,17.107,16.844Zm1.617-2.755a.648.648,0,0,1-.236-.041.83.83,0,0,1-.146-.08.673.673,0,0,1-.238-.785c.051-.137.115-.32.172-.5a.661.661,0,0,1,.633-.471.643.643,0,0,1,.2.031.674.674,0,0,1,.438.84c-.057.174-.121.365-.2.58A.674.674,0,0,1,18.725,14.089ZM15.16,13.78a.464.464,0,0,1-.234-.059L8.99,10.634V4.1a.509.509,0,1,1,1.018,0v5.911l5.383,2.8a.517.517,0,0,1,.254.3.511.511,0,0,1-.484.664Zm4.174-2.824h-.016a.7.7,0,0,1-.367-.123.679.679,0,0,1-.281-.564c0-.207,0-.375,0-.531a.666.666,0,0,1,.637-.7h.016a.007.007,0,0,0,.006,0h0a.664.664,0,0,1,.666.646C20,9.905,20,10.1,20,10.3A.671.671,0,0,1,19.334,10.956Zm-.473-3.162a.662.662,0,0,1-.383-.123.669.669,0,0,1-.246-.336c-.051-.156-.111-.32-.184-.5a.675.675,0,0,1,.371-.873.653.653,0,0,1,.248-.049.66.66,0,0,1,.615.422c.084.209.156.418.211.578a.672.672,0,0,1-.422.846A.723.723,0,0,1,18.861,7.794Z"
                      transform="translate(0)" fill="#F87F0F" />
                  </svg>
                </div>
                <div class="item">
                  <div class="label"> {{ 'bookademo.Meeting duration' | translate }}</div>
                  <div class="value">{{details.meetingDuration}}  {{ 'bookademo.mins' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="one-item">
                  <div>
                    <span class="label-text">
                      {{ 'meetings.Requested by' | translate }}
                    </span>
                  </div>
                  <div>
                    <span class="label-value">
                      {{details.requestBy}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="one-item">
                  <div>
                    <span class="label-text">
                      {{ 'meetings.Requested on' | translate }}
                    </span>
                  </div>
                  <div>
                    <span class="label-value">
                      {{details.requestedOn | date : 'd MMM, y (h:mm a)'}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="details.email">
              <div class="col-12">
                <div class="one-item">
                  <div>
                    <span class="label-text">
                      {{ 'meetings.Email' | translate }}
                    </span>
                  </div>
                  <div>
                    <span class="label-value linkable">
                      {{details.email}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="details.phoneNumber">
              <div class="col-12">
                <div class="one-item">
                  <div>
                    <span class="label-text">
                      {{ 'meetings.Contact No.' | translate }}
                    </span>
                  </div>
                  <div>
                    <span class="label-value">
                       {{details.phoneExtension}} {{details.phoneNumber}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="emails.length">
              <div class="col-12">
                <div class="one-item">
                  <div>
                    <span class="label-text">
                      {{ 'meetings.Guest Email(s)' | translate }}
                    </span>
                  </div>
                  <div>
                    <span class="label-value linkable" *ngFor="let email of emails;let i = index" [ngClass]="{'pt-1': i > 0}" >
                      {{email}}
                    </span>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="floating-footer">
          <div class="btns" *ngIf="details.status == 1">
            <a class="primary-btn accept" mat-raised-button color="primary" (click)="ConfirmDemoRequest(details.id)">
              <span>{{ 'meetings.Accept & Confirm' | translate }}</span>
            </a>
            <a class="primary-btn decline" mat-raised-button color="primary"  (click)="DeclineDemoRequest(details.id)">
              <span>{{ 'meetings.Decline Request' | translate }}</span>
            </a>
            <a class="primary-btn reschedule" mat-raised-button color="primary"  (click)="openDialog(details.id)">
              <span>{{ 'meetings.Reschedule' | translate }}</span>
            </a>
          </div>
          <div class="details-items pb-0" *ngIf="details.status != 1">
            <div class="one-item">
              <div>
                <span class="label-text">
                  {{ 'meetings.Cofirmed on' | translate }}
                </span>
              </div>
              <div>
                <span class="label-value text-nowrap">
                 {{details.confirmedOn |  date: 'd MMM, y (h:mm a)'}}
                </span>
              </div>
            </div>
            <div class="one-item">
              <a class="primary-btn reschedule" mat-raised-button color="primary" (click)="ChangeDecision(details.id)">
                <span>{{ 'meetings.Change Decision' | translate }}</span>
              </a>
            </div>
            <div class="one-item">
              <div>
                <span class="label-text">
                  {{ 'meetings.You can change decision before' | translate }}
                  (
                    {{details.changedDate | date: 'fullDate'}}
                    {{'0000-00-00T' + details.meetingTime  | date:'h:mm aa'}}
                  )

                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

</div>
